import type { ComponentChild } from "preact";

export type KVPair = [label: string, value: ComponentChild];

interface KVProps {
  pairs: KVPair[];
  /** Se true, filtra entradas com value vazio (null, undefined, "", [], 0-len). */
  filterEmpty?: boolean;
}

function isEmpty(v: ComponentChild): boolean {
  if (v == null || v === "") return true;
  if (Array.isArray(v) && v.length === 0) return true;
  return false;
}

export function KV({ pairs, filterEmpty }: KVProps) {
  const visible = filterEmpty ? pairs.filter(([, v]) => !isEmpty(v)) : pairs;
  return (
    <dl class="kv">
      {visible.map(([k, v]) => (
        <>
          <dt>{k}</dt>
          <dd>{isEmpty(v) ? "—" : v}</dd>
        </>
      ))}
    </dl>
  );
}
